<template>
    <v-container id="campaigns">
        <v-row class="justify-between align-center mb-7">
            <v-col cols="12" md="auto">
                <v-btn
                    class="accent shadow-4 px-8"
                    @click="showMessageForm()"
                    large
                    rounded
                >
                    Añadir nuevo mensaje
                </v-btn>
            </v-col>
        </v-row>

        <v-data-table
            :loading="isLoading"
            :headers="headers"
            :items="messageList"
            item-key="id"
            :server-items-length="totalEl"
            :options.sync="tableOptions"
        >
            <template v-slot:[`item.action`]="{ item }">
                <!-- Open -->
                <v-hover v-slot:default="{ hover }">
                    <v-btn
                        text
                        icon
                        :color="hover ? 'accent' : 'blue-grey'"
                        @click.stop="toggleMessageDetail(item)"
                    >
                        <v-icon>mdi-eye</v-icon>
                    </v-btn>
                </v-hover>
                <!-- Edit -->
                <v-hover v-slot:default="{ hover }">
                    <v-btn
                        text
                        icon
                        :color="hover ? 'accent' : 'blue-grey'"
                        @click.stop="showMessageForm(item)"
                    >
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </v-hover>
                <!-- Delete -->
                <v-hover v-slot:default="{ hover }">
                    <v-btn
                        text
                        icon
                        :color="hover ? 'error' : 'blue-grey'"
                        @click.stop="showDeleteDialog(item)"
                    >
                        <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                </v-hover>
            </template>
        </v-data-table>
        <details-dialog
            v-if="isOpenDetails"
            :isOpenDetails="isOpenDetails"
            :item="itemSelected"
            @dialog:close="toggleMessageDetail()"
        ></details-dialog>
        <form-dialog
            v-if="isOpenForm"
            :isActive="isOpenForm"
            :item="itemSelected"
            :isEditMode="isEditMode"
            @dialog:close="closeMessageForm"
        ></form-dialog>
        <delete-dialog
            v-if="isOpenDelete"
            :isOpen="isOpenDelete"
            :item="itemSelected"
            @dialog:close="closeDeleteDialog"
        ></delete-dialog>
    </v-container>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import DetailsDialog from "@/components/UserMessages/DetailsDialog.vue";
import FormDialog from "@/components/UserMessages/FormDialog.vue";
import DeleteDialog from "@/components/UserMessages/DeleteDialog.vue";
export default {
    components: { DetailsDialog, FormDialog, DeleteDialog },
    data() {
        return {
            isLoading: true,
            isOpenDetails: false,
            isEditMode: false,
            isOpenForm: false,
            isOpenDelete: false,
            headers: [
                { text: "Titulo", value: "title", width: "30%" },
                { text: "Fecha de Creado", value: "created_at", width: "30%" },
                { text: "Tipo", value: "type", width: "20%" },
                { text: "Acciones", value: "action", width: "20%" }
            ],
            messageList: [],
            tableOptions: {},
            page: 1,
            totalEl: 0,
            itemSelected: {}
        };
    },
    created() {
        this.getMessages();
    },
    watch: {
        tableOptions: {
            handler() {
                this.getMessages();
            },
            deep: true
        }
    },
    methods: {
        async getMessages() {
            this.isLoading = true;
            const page = this.tableOptions.page || 1;
            const itemPerPage = this.tableOptions.itemsPerPage || 10;
            try {
                const { data } = await PbxHttpClient.get("/admin/message", {
                    params: { page, itemPerPage }
                });
                this.messageList = data.data;
                this.totalEl = data.total;
            } catch (err) {
                console.log(err);
            }
            this.isLoading = false;
        },
        toggleMessageDetail(item = null) {
            this.isOpenDetails = !this.isOpenDetails;
            this.itemSelected = item ? item : null;
        },
        showMessageForm(item = null) {
            this.isOpenForm = true;
            this.itemSelected = item;
            this.isEditMode = item ? true : false;
        },
        closeMessageForm(itRefresh) {
            this.isOpenForm = false;
            this.itemSelected = false;
            if (itRefresh) this.getMessages();
        },
        showDeleteDialog(item) {
            this.isOpenDelete = true;
            this.itemSelected = item;
        },
        closeDeleteDialog(itRefresh) {
            if (itRefresh) this.getMessages();
            this.isOpenDelete = false;
            this.itemSelected = null;
        }
    }
};
</script>
